<div class="desktop-full-screen-overlay--flex payment-dialog">
  <div>
    <app-form-container [title]="modalTitle | translate" class="sale-trip__dialog-form-container"
      (onCancel)="onCancel()" (onSubmit)="onConfirm()" [confirmDisabled]="confirmForm.invalid"
      [additionalActionText]="canOpenOfflinePayment ? 'webPos.OfflinePayment' : null"
      [additionalActionDisabled]="confirmForm.invalid" (onAdditionalAction)="onOfflinePayment()">
      <ng-container form-body [formGroup]="confirmForm">
        <div class="sale-trip__dialog-pay-form">

          @if (!!amountToPay && !isReturn) {
          <div class="sale-trip__dialog-pay-value">
            <span>{{ amountToPayFormatted }}</span>
          </div>
          }

          @if (!!maximumAmountFormatted) {
          <div class="sale-trip__dialog-pay-value">
            <span>{{ 'webPos.Closings.MaximumAmount' | translate }}: {{ maximumAmountFormatted }}</span>
          </div>
          }

          @if (!data?.isReturn && !!data.paymentConditionItems && data.paymentConditionItems.length > 0) {
          <div class="sale-trip__content-payments-container">

            <div class="sale-trip__content-payments-container-label">
              <span>{{ "webPos.CalendarOfPayments" | translate }} </span>
            </div>

            @for (payment of data.paymentConditionItems; track payment.dueDate) {
            <div class="payments-info" [ngClass]="{ selected: selectedDueDates.includes(payment.dueDate) }" (click)="onSelectPayment(payment)">
              <div class="payments-info-block">
                <span>{{ "webPos.Maturity" | translate }}: </span>
                <span>{{ payment.dueDate| localizedDate }}</span>
              </div>
              <div class="payments-info-block payments-info-block--amount">
                <span class="payments-info">
                  {{ payment.amount | hcurrency : payment.currency }}
                </span>
              </div>
            </div>
            }
          </div>
          }

          @if (data.paymentConditionItems.length > 0 && !data.isReturn) {
          <div class="dialog__checkbox-container">
            <input type="checkbox" id="SelectAllCheckbox" class="dialog__checkbox"
              formControlName="selectAllCheckbox" />
            <label for="SelectAllCheckbox" class="dialog__checkbox-label"> {{ "webPos.Global.SelectAll" | translate }}</label>
          </div>
          } @else {
          <div style="flex: 100%; flex: 1;"></div>
          }

          <div class="dialog__input-container">
            <app-form-input label="webPos.ValueToPay"
              [placeholder]="data.isReturn ? ('webPos.ValueToReturn' | translate) : ('webPos.ValueToPay' | translate)"
              [type]="FormInputType.Number" formControlName="amountToPay">
            </app-form-input>
            <span class="input__suffix">{{ stateService.currencyCode() | currencymap }} </span>
          </div>

          @if (hasOverpaymentOverrideError('amountToPay')) {
          <div class="dialog__error">
            <span>{{ 'webPos.Errors.MaxAllowedAmountExceeded' | translate }}</span>
          </div>
          }

          @if (shouldShowOverpaymentOverride('amountToPay')) {
          <div class="dialog__checkbox-container">
            <input type="checkbox" id="AllowOverpaymentCheckbox" class="dialog__checkbox"
              formControlName="allowOverpayment" />
            <label for="AllowOverpaymentCheckbox" class="dialog__checkbox-label">{{ 'webPos.AllowOverpayment' | translate }}</label>
          </div>
          }

          @if (isOverpaymentOverrideEnabled()) {
          <app-form-input [label]="'webPos.OverpaymentReason' | translate"
            [placeholder]="'webPos.OverpaymentReasonPlaceholder' | translate"
            [type]="FormInputType.Textarea" formControlName="overpaymentReason" [maxLength]="500">
          </app-form-input>
          }

        </div>
      </ng-container>
    </app-form-container>
  </div>
</div>
